import { useMutation } from "react-query";
import { useAuthStore } from "../../../store/auth.store";
import { PartnerApi } from "../../../api/partner.api";

export const useLogin = () => {
  const setToken = useAuthStore((state) => state.setToken);
  const setSpecifyPerson = useAuthStore((state) => state.setSpecifyPerson);
  const setRequires2fa = useAuthStore((state) => state.setRequires2fa);
  const setError = useAuthStore((state) => state.setError);

  return useMutation(PartnerApi.login, {
    onSuccess: (data) => {
      // Uložení uživatelských dat do Zustand store
      if ("token" in data) {
        setSpecifyPerson(null);
        setToken(data.token);
        setRequires2fa(false);
        setError(null);
        // Uložení tokenu do LocalStorage
        localStorage.setItem("token", data.token);
      }

      if ("error" in data) {
        setError(data.error);
      }

      if ("code" in data && data.code == 103) {
        setSpecifyPerson(data.data.availablePersons);
      }
      if ("code" in data && data.code == 104) {
        setRequires2fa(true);
      }
    },
    onError: (error) => {
      console.log(error);
      console.error("Login failed:", error);
    },
  });
};
